import { useEffect, useState, useCallback } from 'react';
import { apiFetch } from '@/lib/api.js';

export function useEvents(tenantSlug, { includePast = false } = {}) {
  const [data, setData] = useState({ events: [], count: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    const url = `/api/tenants/${tenantSlug}/events${includePast ? '?all=1' : ''}`;
    apiFetch(url)
      .then((r) => r.json())
      .then((d) => {
        if (d.error) throw new Error(d.error);
        setData({ events: d.events, count: d.count });
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [tenantSlug, includePast]);

  useEffect(load, [load]);

  return { ...data, loading, error, refresh: load };
}
